export default __webpack_public_path__ + "static/media/google-play-badge@3x.43ffcfe4.png";